import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FileHttp, BaseFile } from '@App/app/entities/files/files.model';
import { ATSettings } from '@App/app/entities/processing/at-settings.model';
import { PostProcessingSettings } from '@App/app/entities/processing/build-process-status.model';
import { BuildProcess } from '@App/app/entities/processing/build-process.model';
import { ProductionSettings } from '@App/app/entities/processing/production-settings.model';
import { ApiService } from '@App/app/shared/api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ModelsProcessingHttpService extends ApiService {
  getBuildProcess(id: number): Observable<BuildProcess> {
    return this.http.get<BuildProcess>(`${this.api}/buildProcess/${id}`, {
      params: { expanded: 'true' },
    });
  }

  getBuildProcessFiles(id: number): Observable<BaseFile[]> {
    return this.http.get<BaseFile[]>(`${this.api}/buildProcess/${id}/files`);
  }

  putBuildProcessFiles(id: number, files: FileHttp[]): Observable<BaseFile[]> {
    return this.http.put<BaseFile[]>(`${this.api}/buildProcess/${id}/files`, files);
  }

  getBuildProcesses(): Observable<BuildProcess[]> {
    return this.http.get<BuildProcess[]>(`${this.api}/buildProcess`, {
      params: { expanded: 'true' },
    });
  }

  getBuildProcessLogs(url: string): Observable<string> {
    return this.http.get(url, { responseType: 'text', headers: { notLogOutOn403: 'true' } });
  }

  putBuildProcess(process: BuildProcess): Observable<BuildProcess> {
    return this.http.put<BuildProcess>(`${this.api}/buildProcess/${process.id}`, process.toHttp());
  }

  deleteBuildProcess(id: number, force = false): Observable<unknown> {
    const options = { params: new HttpParams() };
    if (force) {
      options.params = options.params.set('force', `${force}`);
    }
    return this.http.delete<unknown>(`${this.api}/buildProcess/${id}`, options);
  }

  startAerotriangulation(
    id: number,
    aerotriangulationSettings: Partial<ATSettings>,
  ): Observable<BuildProcess> {
    return this.http.post<BuildProcess>(
      `${this.api}/buildProcess/${id}/aerotriangulation/start`,
      aerotriangulationSettings,
    );
  }

  startProduction(
    id: number,
    payload: {
      productionSettings: Partial<ProductionSettings>;
      productionFormats: { withObj: boolean; withOrthoDsm: boolean; withPointCloud: boolean };
    },
  ): Observable<BuildProcess> {
    return this.http.post<BuildProcess>(`${this.api}/buildProcess/${id}/production/start`, payload);
  }

  startPostProcessing(id: number, postProcessingSettings: PostProcessingSettings) {
    return this.http.post<BuildProcess>(
      `${this.api}/buildProcess/${id}/post-processing/start`,
      postProcessingSettings,
    );
  }

  toggleSubscribeBuildProcess(id: number, subscribe: boolean): Observable<BuildProcess> {
    return this.http.post<BuildProcess>(
      `${this.api}/buildProcess/${subscribe ? 'subscribe' : 'unsubscribe'}/${id}`,
      {},
    );
  }
}
